const e="undefined"!=typeof window&&window.newrelic&&"object"==typeof window.newrelic,w=(w,n)=>{e&&window.newrelic.addPageAction(w,n)},n=(w,n)=>{e&&window.newrelic.setCustomAttribute(w,n)};export{w as addNewRelicPageAction,n as setNewRelicCustomAttribute};
//# sourceMappingURL=es.js.map
